import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  token: string;
  retrieveDocumentEditionToken(
    request: Boundaries["retrieveDocumentEditionToken"]["request"],
  ): void;
}

function useDocumentEditionTokenRetrieval(key: string): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveDocumentEditionTokenPending(key),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveDocumentEditionTokenSuccess(key),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveDocumentEditionTokenFailure(key),
    ),
    token: useSelector(() => selector.getToken(key)),
    retrieveDocumentEditionToken: core.retrieveDocumentEditionToken,
  };
}

export { useDocumentEditionTokenRetrieval };
